module.exports = __webpack_public_path__ + "v1.8.4.20261010/img/phone.9aae3b1a.png";